import React from 'react'

export default class IconsLandingPage extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M13.3333 2.66669H2.66665C1.93027 2.66669 1.33331 3.26364 1.33331 4.00002V12C1.33331 12.7364 1.93027 13.3334 2.66665 13.3334H13.3333C14.0697 13.3334 14.6666 12.7364 14.6666 12V4.00002C14.6666 3.26364 14.0697 2.66669 13.3333 2.66669Z'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M6.66669 2.66669V5.33335'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M1.33331 5.33331H14.6666'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4 2.66669V5.33335'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
